export default { sha: 'ea9e46b7d6764a5382f96898d68111d85543bac9', buildNumber: 'undefined' }
